import OtpLogList from "@/features/otp-log/ui/otp-log-list";

export default function OtpLog() {
  return <OtpLogList />;
}

